import useBranch from "@hooks/useBranch/useBranch";

const BranchConfiguration = () => {
  useBranch();

  return null;
};

export default BranchConfiguration;
